import { render, staticRenderFns } from "./BpFaq.vue?vue&type=template&id=318abf9a&"
import script from "./BpFaq.vue?vue&type=script&lang=js&"
export * from "./BpFaq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports